// import React, { useRef, useEffect } from "react";

// const ITEM_HEIGHT = 40;

// const ScrollColumn = ({ items, selected, onSelect }) => {
//   const ref = useRef(null);
//   const timeoutRef = useRef(null);

//   useEffect(() => {
//     const el = ref.current;
//     const index = items.indexOf(selected);
//     if (index !== -1 && el) {
//       const maxScrollTop = (items.length - 1) * ITEM_HEIGHT;
//       el.scrollTo({
//         top: Math.min(index * ITEM_HEIGHT, maxScrollTop),
//         behavior: "smooth",
//       });
//     }
//   }, [selected, items]);

//   const handleScroll = () => {
//     const el = ref.current;
//     const scrollTop = el.scrollTop;

//     clearTimeout(timeoutRef.current);
//     timeoutRef.current = setTimeout(() => {
//       const index = Math.round(scrollTop / ITEM_HEIGHT);
//       const clampedIndex = Math.min(Math.max(0, index), items.length - 1);
//       onSelect(items[clampedIndex]);

//       // Snap to item
//       el.scrollTo({
//         top: clampedIndex * ITEM_HEIGHT,
//         behavior: "smooth",
//       });
//     }, 100);
//   };

//   return (
//     <div className="picker-column" ref={ref} onScroll={handleScroll}>
//       {items.map((item, index) => (
//         <div
//           key={index}
//           className={`picker-item ${item === selected ? "active" : ""}`}
//         >
//           {item}
//         </div>
//       ))}
//     </div>
//   );
// };

// const ScrollTimePicker = ({ onChange, setMinute, hour, setHour, minute }) => {
//   const hours = Array.from({ length: 13 }, (_, i) =>
//     String(i).padStart(2, "0")
//   );
//   const minutes = Array.from({ length: 61 }, (_, i) =>
//     String(i).padStart(2, "0")
//   );

//   //   useEffect(() => {
//   //     onChange?.(`${hour}:${minute}`);
//   //   }, [hour, minute, onChange]);

//   return (
//     <div className="time-picker-container">
//       <div className="highlight-overlay" />
//       <ScrollColumn items={hours} selected={hour} onSelect={setHour} />
//       <div className="picker-separator">:</div>
//       <ScrollColumn items={minutes} selected={minute} onSelect={setMinute} />
//     </div>
//   );
// };

// export default ScrollTimePicker;

import React, { useRef, useEffect } from "react";

const ITEM_HEIGHT = 40;

const ScrollColumn = ({ items, selected, onSelect }) => {
  const ref = useRef(null);
  const timeoutRef = useRef(null);

  // Scroll to selected on change
  useEffect(() => {
    const el = ref.current;
    const index = items.indexOf(selected);
    if (index !== -1 && el) {
      el.scrollTo({
        top: index * ITEM_HEIGHT,
        behavior: "smooth",
      });
    }
  }, [selected, items]);

  const handleScroll = () => {
    const el = ref.current;
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      const index = Math.round(el.scrollTop / ITEM_HEIGHT);
      const clampedIndex = Math.min(Math.max(0, index), items.length - 1);
      onSelect(items[clampedIndex]);

      el.scrollTo({
        top: clampedIndex * ITEM_HEIGHT,
        behavior: "smooth",
      });
    }, 100);
  };

  const handleClick = (index) => {
    const el = ref.current;
    el.scrollTo({
      top: index * ITEM_HEIGHT,
      behavior: "smooth",
    });
    onSelect(items[index]);
  };

  return (
    <div className="picker-column" ref={ref} onScroll={handleScroll}>
      {items.map((item, index) => (
        <div
          key={index}
          className={`picker-item ${item === selected ? "active" : ""}`}
          onClick={() => handleClick(index)}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

const ScrollTimePicker = ({ onChange, hour, setHour, minute, setMinute }) => {
  const hours = Array.from({ length: 24 }, (_, i) =>
    String(i).padStart(2, "0")
  );
  const minutes = Array.from({ length: 60 }, (_, i) =>
    String(i).padStart(2, "0")
  );

  useEffect(() => {
    onChange?.(`${hour}:${minute}`);
  }, [hour, minute, onChange]);

  return (
    <div className="time-picker-container">
      <div className="highlight-overlay" />
      <ScrollColumn items={hours} selected={hour} onSelect={setHour} />
      <div className="picker-separator">:</div>
      <ScrollColumn items={minutes} selected={minute} onSelect={setMinute} />
    </div>
  );
};

export default ScrollTimePicker;
